import React from 'react';
import { resumeFormSection as s } from './supportContent';

// Plain <a download> (not <Link>): /downloads/* is a static file served by
// the dev server / express.static, not a React Router route.
const ResumeFormCallout = () => (
  <section className="support-section support-form-callout">
    <h2 className="support-section-title">{s.title}</h2>
    <p className="support-section-description">{s.intro}</p>
    <p className="support-form-link">
      <a href={s.href} download>{s.linkText}</a>
    </p>
    <p className="support-form-note">{s.linkNote}</p>
    <p className="support-form-gather-title">{s.gatherTitle}</p>
    <ul className="support-form-list">
      {s.gather.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
    {s.notes.map((note) => (
      <p key={note} className="support-form-note">{note}</p>
    ))}
  </section>
);

export default ResumeFormCallout;
